import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import "@fontsource/permanent-marker/latin-400.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import { App } from "./App.js";
import { installErrorReporting } from "../shared/lib/report-errors.js";
import "../shared/styles/tokens.css";
import "../shared/styles/theme.css";
import "../shared/styles/global.css";

// Vor dem Render registrieren, damit auch Fehler beim ersten Mount ankommen.
installErrorReporting();
registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
